var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "display-block", attrs: { id: "display-block" } },
    [
      _c(
        "div",
        {
          staticClass: "emap-container",
          class: {
            "emap-container--hide": _vm.is_atlas || _vm.is_monitor,
            "emap-container--monitor":
              _vm.is_monitor && _vm.is_monitor_open_emap
          }
        },
        [
          _vm.has_got_map_config_from_server
            ? _c("EMapVue", {
                ref: "emap",
                attrs: {
                  origin_selected_products: _vm.selected_products,
                  keep_group_list: _vm.keep_group_list,
                  multiple_group_list: _vm.multiple_group_list,
                  timeless_list: _vm.timeless_list,
                  config: _vm.config,
                  selected_geomap_products: _vm.selected_background_products,
                  information: [],
                  map_config_from_server: _vm.map_config_from_server,
                  is_show_favorites: _vm.is_show_favorites
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.atlas_loaded
        ? _c("AtlasBlock", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.is_atlas,
                expression: "is_atlas"
              }
            ]
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.monitor_loaded
        ? _c("MonitorBlock", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.is_monitor,
                expression: "is_monitor"
              }
            ]
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }